<template>
  <div class="rectifyBox">
    <div class="innerBox content">
      <div class="innerTitle">
        <!-- <el-button type="primary" size="small" @click="add">新增</el-button> -->
        <div class="screenBox">
          <el-select v-model="searchForm.status" size="small" style="width: 100%" placeholder="状态" @change="selectChange" clearable>
            <el-option v-for="item in statusList" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </div>
      </div>
      <div class="tableBox">
        <el-table
        :data="tableData"
        border
        :header-cell-style="{ background: 'rgb(232,232,232)', height: '55px', textAlign: 'center' }"
        :row-style="{ height: '55px' }"
        :cell-style="{ textAlign: 'center' }"
        style="width: 100%">
        <el-table-column
          type="index"
          :index='(index) => {return index + 1 + (curPage-1)*limit}'
          label="序号"
          width="100">
        </el-table-column>
        <el-table-column
          prop="indicatorNumber"
          label="指标编号">
          <template slot-scope="{ row }">
            <el-link type="primary" @click="jumpSplitDetail(row.objIndChildId)">{{ row.indicatorNumber }}</el-link>
          </template>
        </el-table-column>
        <el-table-column
          prop="abarbeitungDepName"
          label="整改部门">
        </el-table-column>
        <el-table-column
          prop="abarbeitungDutyName"
          label="整改负责人" />
        <el-table-column
          prop="abarbeitungCompletionTime"
          label="整改期限" />
        <el-table-column
          prop="reCheckDepName"
          label="复核部门">
        </el-table-column>
        <el-table-column
          label="复核负责人"
          prop="reCheckEmpName">
        </el-table-column>
        <el-table-column
          prop="status"
          label="状态">
          <template slot-scope="{ row }">
            <span v-if="row.status === 0" style="color: #E6A23C">待复核</span>
            <span v-if="row.status === 1" style="color: #67C23A">合格</span>
            <span v-if="row.status === 2" style="color: #F56C6C">不合格</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作">
          <template slot-scope="{ row }">
            <el-link type="primary" style="margin-right: 10px" @click="edit(row)" v-if="row.status === 0">编辑</el-link>
            <el-link type="primary" style="margin-right: 10px; color: #E6A23C" @click="detail(row.id)">详情</el-link>
            <el-link type="primary" style="margin-right: 10px;color: red" @click="review(row)" v-if="row.reCheckUserId == userId">复核</el-link>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 15px; text-align: right">
        <Page :total='total' :page-size='limit' :current='curPage' @on-change='curPageChange' />
      </div>
      </div>
    </div>
    <!-- 复核的弹窗 -->
    <el-dialog
      title="复核"
      :visible.sync="dialogVisible"
      @close="closeDia"
      width="30%">
      <el-form :model="diaForm" ref="diaForm" :rules="diaRules" size="small" label-width="80px">
        <el-form-item label="复核时间" prop="reCheckTime">
          <el-date-picker
            v-model="diaForm.reCheckTime"
            type="date"
            style="width: 100%"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="复核内容" prop="reCheckContent">
          <el-input type="textarea" v-model="diaForm.reCheckContent" :rows="3" />
        </el-form-item>
        <el-form-item label="复核状态" prop="status">
          <el-radio-group v-model="diaForm.status">
            <el-radio-button :label="1">通过</el-radio-button>
            <el-radio-button :label="2">不通过</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDia" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm" size="small">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { rectifyTargetList, rectifyReview } from '@/api/processManager'
export default {
  name: 'mainTarget',
  data() {
    return {
      userId: '',
      searchForm: {
        status: ''
      },
      statusList: [
        { id: 0, name: '待复核' },
        { id: 1, name: '合格' },
        { id: 2, name: '不合格' },
      ],
      tableData: [],
      limit: 10,
      total: 0,
      curPage: 1,
      dialogVisible: false,
      diaForm: {
        reCheckTime: '',
        reCheckContent: '',
        status: 1
      },
      diaRules: {
        reCheckTime: [{ required: true, message: '请选择复核时间' }],
        reCheckContent: [{ required: true, message: '请输入复核内容' }],
      }
    }
  },
  created() {
    this.userId = localStorage.getItem('userId');
    this.getData()
  },
  methods: {
    // 获取数据
    getData() {
      rectifyTargetList({ limit: this.limit, isPage: 1, curPage: this.curPage, ...this.searchForm }).then(res => {
        this.tableData = res.body.data;
        this.total = res.body.total
      })
    },
    // 下拉框选择的事件
    selectChange() {
      this.getData();
    },
    // 翻页
    curPageChange(val) {
      this.curPage = val;
      this.getData();
    },
    // 新增按钮
    add() {
      this.$router.push({
        path: 'checkTargetAdd'
      })
    },
    // 编辑
    edit(row) {
      this.$router.push({
        name: 'rectifyTargetAdd',
        params: { ...row }
      })
    },
    // 复核的弹窗
    review(row) {
      this.dialogVisible = true;
      this.diaForm.id = row.id
    },
    // 关闭弹窗
    closeDia() {
      this.$refs['diaForm'].resetFields();
      this.dialogVisible = false;
    },
    // 提交表单
    submitForm() {
      this.$refs['diaForm'].validate((valid) => {
        if (valid) {
          rectifyReview({...this.diaForm}).then(res => {
            this.getData();
            this.$message.success('复核成功')
            this.closeDia();
          })
        } else {
          return false;
        }
      });
    },
    // 跳转到目标拆分详情页面
    jumpSplitDetail(id) {
      this.$router.push(`splitDetail/${id}`)
    },
    // 详情/审核
    detail(id) {
      this.$router.push(`rectifyDetail/${id}`)
    }
  }
}
</script>

<style scoped>
.innerTitle {
  /* display: flex; */
  /* justify-content: space-between; */
  /* margin-bottom: 5px; */
  /* align-items: flex-end */
  /* margin-bottom: 15px; */
  height: 45px;
}
.innerTitle .screenBox {
  width: 15%;
  display: flex;
  justify-content: space-between;
  float: right;
}
.rectifyBox /deep/ .el-dialog__body {
  padding-bottom: 0
}
</style>